import React, { ComponentProps } from 'react';
import { Image as DesignSystemImage } from '@plerionhq/design-system';
import type { ImageProps } from '@plerionhq/design-system';
import { ExtensionImage } from './ExtensionImage';
import { isExtension } from '../../browser-extension/utils/extension-utils';

export const Image = (props: ComponentProps<typeof DesignSystemImage>) => {
  // Use extension-safe image loading when running in browser extension context
  if (isExtension) {
    return <ExtensionImage {...props} />;
  }

  // Fall back to original implementation for web app
  return (
    <DesignSystemImage
      baseUrl={`https://${process.env.API_URL || window?.location?.host}`}
      {...props}
    />
  );
};

export type { ImageProps };
